import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Confirmations Turbo (data-turbo-confirm) dans la boîte de dialogue système de
// l'app, à la place du <dialog> web (turbo/confirm.js). Posé sur le <body> des
// pages natives ; le natif répond { confirmed } quel que soit le choix.
export default class extends BridgeComponent {
  static component = 'confirm'

  ask({ title, message, confirmLabel, destructive }) {
    return new Promise((resolve) => {
      this.send('show', { title, message, confirmLabel, destructive }, (reply) => {
        resolve(reply.data?.confirmed === true)
      })
    })
  }
}
